<script setup lang="ts">
import type { ToastProps } from 'primevue/toast';

import useQaAutoId from '@modules/core/qa-automation/utils/useQaAutoId';

interface TheToastProps {
  position?: ToastProps['position'];
  group?: ToastProps['group'];
}

withDefaults(defineProps<TheToastProps>(), {
  position: 'bottom-right',
});

const { getQaAutoIdAttribute } = useQaAutoId();
</script>

<template>
  <PToast
    :position="position"
    :group="group"
    :pt="{
      root: {
        class: 'max-w-[calc(100vw-40px)]',
      },
      container: {
        ...getQaAutoIdAttribute(),
      },
      icon: 'self-center',
    }"
  />
</template>
